import React from 'react';

export const VerticalSpacer = () => (
    <div className="my-2 border-got-dark border-r opacity-25" />
);
